import {register} from '../modules/eventMap';
import {longPoll} from './poll';
import {resetFormLoading} from './formSubmit';

const chatPromptSelector = '[data-kui-chat-prompt]';
const chatLogSelector = '[data-kui-chat-log]';

const updateUI = (jobId) => (res, data) => {
    const {progress} = res;
    const elementId = `id_make_response_${jobId}`;

    if (!document.getElementById(elementId)) {
        const div = document.createElement('div');
        div.id = elementId;
        document.querySelector(chatLogSelector).appendChild(div);
    }

    const container = document.getElementById(elementId);

    if (progress && progress.length > 0) {
        progress.forEach((item) => {
            container.append(item.progress.delta);
            container.scrollIntoView({behavior: 'smooth', block: 'end'});
            // todo: handle formatting, escaping
        });
        data.set('p_last_progress', progress[progress.length - 1].id);
    }
    return {ok: true, data};
};

const make = () => {
    register('make', {
        start: makeHandler
    });
};

const makeHandler = (res) => {
    const {event} = res;

    const promptContainer = document.querySelector(chatPromptSelector);
    const [textArea] = promptContainer.getElementsByTagName('textarea');

    switch (event) {
        case 'start': {
            const {job_id, project_id, prompt} = res;

            textArea.value = '';
            textArea.disabled = true;

            const div = document.createElement('div');
            div.append(prompt);
            document.querySelector(chatLogSelector).appendChild(div);
            div.scrollIntoView();

            const formData = new FormData();
            formData.append('p_job_id', job_id);
            formData.append('project_id', project_id);

            longPoll('/make/progress', formData, updateUI(job_id));
            // todo: poll needs to bail out when switching pages
            break;
        }
        // todo: handle failures, for now unlock the chat.
        case 'failure':
        case 'end': {
            textArea.disabled = false;
            textArea.focus();
            const formSubmitBtn = promptContainer.querySelector(
                'button[type="submit"]'
            );
            resetFormLoading(formSubmitBtn);
            break;
        }
        default: {
            break;
        }
    }
};

export {make, makeHandler};
